import { toast } from "react-toastify"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"

export const TarifierungActions = ({
    getDataFromPointer,
    getDataFromBackend,
    sendDataToBackend,
    navigate,
    loadCurrentLocationData,
}) => {
    return {
        INIT_TARIFIERUNG: () => {
            loadCurrentLocationData("/tarifierung/list")
        },
        TARIFIERUNG_ERSTELLEN: () => {
            getDataFromBackend(
                getDataFromPointer("/links/tarifierung:create"),
                "/tarifierung",
            ).then((tarifierungResponse) => {
                const links = tarifierungResponse?._data?._links
                if (links) {
                    const link = links?.loadGruppenUndEinzelUnfall ?? links?.["tarifierung:load:versicherungsumfang"]

                    navigate(pathBuilder(link));
                }
            })
        },

        TARIFIERUNG_LADEN: ({payload}) => {
            if (payload._links?.loadGruppenUndEinzelUnfall) {
                navigate(
                    pathBuilder(
                        payload._links?.loadGruppenUndEinzelUnfall,
                    ),
                )
            } else {
                navigate(
                    pathBuilder(
                        payload._links["tarifierung:load:versicherungsumfang"],
                    ),
                )
            }
        },
        TARIFIERUNG_DRUCKEN: ({payload}) => {
            sendDataToBackend(
                payload._links.printAngebotPdf,
                {},
            ).then(() => {
                toast.success("Druckstück wurde erfolgreich im Druckcenter abgelegt")
            })


        }
    }
}
